
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.734 3.65v7.128c0 1.473 1.1 2.678 2.49 2.772l.176.006h4.709c-.22.647-.813 1.11-1.509 1.11H5.867c-1.768 0-3.2-1.492-3.2-3.332V5.222c0-.725.445-1.343 1.067-1.572zm8-2.317c.883 0 1.6.747 1.6 1.667v7.778c0 .92-.717 1.667-1.6 1.667H6.4c-.884 0-1.6-.747-1.6-1.667V3c0-.92.716-1.667 1.6-1.667h5.333zm0 1.112H6.4A.545.545 0 005.867 3v7.778c0 .307.238.556.533.556h5.333a.545.545 0 00.534-.556V3a.545.545 0 00-.534-.555z","fill":"#9DA7B2"}})])
          )
        }
      }
    